import { isAuthenticated } from '@akin-home/auth/react';
import { useEffect } from 'react';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';
import {
  focusedChatIsVisible,
  sendMessageToFocusChat,
} from '../chat/focused_chat/functions';
import { sendChatByLoginScreen } from '../screens/LoginScreen/functions';
import { useStateStore } from '../stores/useStateStore';
import { requestAudioPermission } from '../utils/permissions';
import processSTTResponse from './processSTTResponse';

export const startVoiceListening = async () => {
  const hasPermission = await requestAudioPermission();

  if (!hasPermission) {
    // Was not granted access
    console.log('No permission');
    return;
  }

  await SpeechRecognition.startListening();
};

export const stopVoiceListening = SpeechRecognition.stopListening;

const useSTT = () => {
  const startListening = useStateStore((state) => state.startListeningToVoice);
  const stopListening = useStateStore((state) => state.stopListeningToVoice);
  const sendChatMessage = useStateStore((state) => state.sendChatMessage);

  const { listening, finalTranscript } = useSpeechRecognition({
    clearTranscriptOnListen: true,
  });

  useEffect(() => {
    return () => {
      SpeechRecognition.abortListening();
    };
  }, []);

  useEffect(() => {
    if (finalTranscript && finalTranscript !== '') {
      const result = processSTTResponse([finalTranscript]);

      if (focusedChatIsVisible()) {
        // If focused chat is open, send the message there
        sendMessageToFocusChat(result);
      } else if (!isAuthenticated()) {
        sendChatByLoginScreen(result);
      } else {
        // Otherwise send it to the main chat log
        sendChatMessage(result);
      }
    }
  }, [finalTranscript]);

  useEffect(() => {
    listening ? startListening() : stopListening();
  }, [listening]);
};

export default useSTT;
